import { ReactNode } from "react";
import ExclamationIcon from "../../assets/icons/ExclamationIcon";
import { CustomModalProps } from "../../types";
import CustomModal from "./CustomModal";

type ConfirmModalProps<T> = {
  data?: T;
  confirmTitle?: string;
  questionText?: string;
  submitDisabled?: boolean;
  okLoading?: boolean;
  handleOk: (val?: T) => void;
  children?: ReactNode;
  alertClassName?: string;
  hideAlert?: boolean;
  closable?: boolean;
  modalClassName?: string;
  handleCancel?: () => void;
} & CustomModalProps;

export default function ConfirmModal<T>({
  data,
  confirmTitle = "Delete This.",
  questionText = "Are sure to delete this item?",
  okText = "Delete",
  okLoading,
  submitDisabled,
  alertClassName = "",
  disableCloseButton,
  okButtonProps,
  handleOk,
  handleClose,
  handleCancel,
  children,
  hideAlert,
  closable = false,
  modalClassName = "footer-end",
  ...rest
}: ConfirmModalProps<T>) {
  return (
    <CustomModal
      width={400}
      className={`confirm-modal ${modalClassName}`}
      handleClose={handleClose}
      closable={closable}
      okText={okText}
      onOk={() => handleOk(data)}
      okButtonProps={{
        loading: okLoading,
        className: "!rounded",
        ...okButtonProps,
      }}
      cancelButtonProps={{
        className: "cancel-btn",
        onClick: handleCancel || handleClose,
      }}
      {...rest}
    >
      {!hideAlert ? (
        <div className={`flex gap-4 ${alertClassName}`}>
          <ExclamationIcon />
          <div>
            <h4 className="text-body text-lg font-medium leading-normal relative -top-[2.5px]">
              {confirmTitle}
            </h4>
            <p className="text-body text-sm font-normal leading-normal mt-1">
              {questionText}
            </p>
          </div>
        </div>
      ) : null}

      {children}
    </CustomModal>
  );
}
